import React from "react";
import { Props } from "./types";
import styles from "./styles.scss";

function MessageInput({ value, placeholder, input }: Props) {
  return (
    <textarea
      className={styles.messageInput}
      value={value}
      placeholder={placeholder}
      onChange={({ target }) => input(target.value)}
    />
  );
}

export { MessageInput };
